import { h } from 'preact';
import * as BaseComp from 'components/pages/home/home.js';
import s from 'components/pages/home/home.sss';

const isServer = typeof window !== 'undefined';

export default class Home extends BaseComp.default {
	getTitleTreatment(copy, imageRoot, pageData) {
		let props = this.props || {};
		copy = copy || props.appData.copy;
		imageRoot = imageRoot || props.appData.urls.roots.imageRegion;
		pageData = pageData || props.pageData;
		let src = this.sizeBasedTT(pageData && pageData.alternateTT);
		let img = (
			<h1 class={s.titleText} id="titleText">
				<img
					ref={e => (this.$tt = e)}
					alt={copy.$HOME_TITLE_TREATMENT_SEO || 'Movie title'}
					class={s.title}
					src={src}
				/>
				<span>{copy.$HOME_TITLE_TREATMENT_SEO}</span>
			</h1>
		);
		if (pageData && pageData.ttLinkOut && !isServer) {
			// Why do we wrap it in an extra div ?
			return (
				<div class={s.homeTTLinkOut}>
					<Link href={pageData.ttLinkOut} target="_blank" trackId="home-tt-link-out">
						{img}
					</Link>
				</div>
			);
		}
		return img;
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
